/* GraceYears — SKU #7-BF live preview.
   Toa do lay tu BANG_TOADO_BanB_2026-08-12.md (do truc tiep tren file in, ti le 4:5).
   SUA 13/08/2026:
   - k cua quote 0.72 -> 0.82 va k cua names 0.71 -> 0.99: do THAT bang measureText
     (actualBoundingBoxAscent+Descent)/fontSize tren dung 2 font that. Truoc do quote cao
     6.4% thay vi 5.52%, va khoi ten bi phong ~1.39 lan.
   - baseline quote 0.8600 -> 0.8721, names 0.9157 -> 0.9118: neo lai TAM VET MUC dung
     84.52% / 90.80% thay vi neo baseline.
   - Font: Cormorant Garamond wght 400 (khop lop chu tren Printify), khong phai 500.
   - 🔴 VA LOI THAT SU KHACH THAY: render chay TRUOC khi webfont load xong => do bang font
     du phong (Georgia rong hon) => cham san 62% => TEN BI XUONG 2 DONG trong khi ban in
     chi co 1 dong. Nay ep cho document.fonts.load() xong moi ve, va ve lai khi font toi.
   SUA 15/08/2026: n=0 dung nen 7 hoa thay vi 1 hoa (preview khac han anh ban). */
(function () {
  var W = 800, H = 1000;
  var SPEC = {
    quote: { cx: 0.5003, baseline: 0.8721, inkH: 0.0552, maxW: 0.835, hex: '#42413C', font: '"Pinyon Script", cursive', k: 0.82 },
    names: { cx: 0.5000, baseline: 0.9118, inkH: 0.0155, maxW: 0.845, hex: '#5D5950', font: '"Cormorant Garamond", Georgia, serif', k: 0.99, track: 0.06, sep: '  |  ', floor: 0.62, line: 1.25 }
  };
  var MONTHS = {jan:1,january:1,feb:2,february:2,mar:3,march:3,apr:4,april:4,may:5,jun:6,june:6,jul:7,july:7,aug:8,august:8,sep:9,sept:9,september:9,oct:10,october:10,nov:11,november:11,dec:12,december:12};

  function fonts() {
    if (document.getElementById('gy-bf-fonts')) return;
    var l = document.createElement('link');
    l.id = 'gy-bf-fonts'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Pinyon+Script&family=Cormorant+Garamond:wght@400&display=swap';
    document.head.appendChild(l);
  }

  /* CHAN CUNG: chua co du 2 font that thi KHONG duoc ve. */
  function fontsReady() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all([
      document.fonts.load('67px "Pinyon Script"', "Grandma's Garden"),
      document.fonts.load('16px "Cormorant Garamond"', 'MARGARET')
    ]).catch(function () {});
  }

  function field(key) {
    return document.querySelector('[name="properties[' + key + ']"]');
  }

  function parseNames(raw) {
    var out = [];
    (raw || '').split(/\r?\n/).forEach(function (line) {
      var s = line.trim(); if (!s) return;
      var parts = s.split(/\s*[-–—,]\s*/);
      var name = (parts[0] || '').trim();
      if (!name) return;
      var m = (parts[1] || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
      var mo = MONTHS[m] || (parseInt(m, 10) >= 1 && parseInt(m, 10) <= 12 ? parseInt(m, 10) : 0);
      out.push({ name: name, month: mo });
    });
    return out.slice(0, 12);
  }

  function bgFor(n) {
    var map = window.GY_BF_BG || {};
    var key = n === 0 ? 7 : (n <= 3 ? 1 : (n <= 9 ? 7 : 12));
    return map[key] || map[7] || map[1] || '';
  }

  function trackedWidth(ctx, txt, track, size) {
    return ctx.measureText(txt).width + Math.max(0, txt.length - 1) * track * size;
  }

  function drawTracked(ctx, txt, cx, y, track, size) {
    var w = trackedWidth(ctx, txt, track, size);
    var x = cx - w / 2;
    for (var i = 0; i < txt.length; i++) {
      var ch = txt[i];
      ctx.fillText(ch, x, y);
      x += ctx.measureText(ch).width + track * size;
    }
  }

  var imgCache = {};
  function loadImg(src, cb) {
    if (!src) return cb(null);
    if (imgCache[src]) return cb(imgCache[src]);
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { imgCache[src] = im; cb(im); };
    im.onerror = function () { cb(null); };
    im.src = src;
  }

  function render(cv) {
    var ctx = cv.getContext('2d');
    var quote = (field('Title line') && field('Title line').value.trim()) || "Grandma's Garden";
    var people = parseNames(field('Names and birth months') && field('Names and birth months').value);
    var n = people.length;

    loadImg(bgFor(n), function (im) {
      ctx.clearRect(0, 0, W, H);
      if (im) ctx.drawImage(im, 0, 0, W, H);
      else { ctx.fillStyle = '#FBF8F1'; ctx.fillRect(0, 0, W, H); }

      // QUOTE — neo TAM vet muc o 84.52% chieu cao
      var q = SPEC.quote;
      var size = (q.inkH * H) / q.k;
      ctx.textBaseline = 'alphabetic'; ctx.textAlign = 'center';
      ctx.fillStyle = q.hex;
      ctx.font = size + 'px ' + q.font;
      var maxW = q.maxW * W;
      if (ctx.measureText(quote).width > maxW) {
        size = size * Math.max(0.7, maxW / ctx.measureText(quote).width);
        ctx.font = size + 'px ' + q.font;
      }
      ctx.fillText(quote, q.cx * W, q.baseline * H);

      // NAMES — luon 1 dong, chi xuong 2 dong khi da cham san 62%
      if (!n) return;
      var s = SPEC.names;
      var nsize = (s.inkH * H) / s.k;
      var txt = people.map(function (p) { return p.name.toUpperCase(); }).join(s.sep);
      ctx.textAlign = 'left'; ctx.fillStyle = s.hex;
      ctx.font = nsize + 'px ' + s.font;
      var allow = s.maxW * W;
      var w = trackedWidth(ctx, txt, s.track, nsize);
      if (w > allow) {
        var f = Math.max(s.floor, allow / w);
        nsize = nsize * f;
        ctx.font = nsize + 'px ' + s.font;
        w = trackedWidth(ctx, txt, s.track, nsize);
      }
      if (w <= allow) {
        drawTracked(ctx, txt, s.cx * W, s.baseline * H, s.track, nsize);
      } else {
        var half = Math.ceil(people.length / 2);
        var l1 = people.slice(0, half).map(function (p) { return p.name.toUpperCase(); }).join(s.sep);
        var l2 = people.slice(half).map(function (p) { return p.name.toUpperCase(); }).join(s.sep);
        var lead = nsize * s.line;
        drawTracked(ctx, l1, s.cx * W, s.baseline * H - lead, s.track, nsize);
        drawTracked(ctx, l2, s.cx * W, s.baseline * H, s.track, nsize);
      }
    });
  }

  function boot() {
    var host = document.getElementById('gy-bf');
    if (!host || !field('Names and birth months')) return setTimeout(boot, 400);
    fonts();
    host.innerHTML = '<canvas id="gy-bf-cv" width="' + W + '" height="' + H + '" style="width:100%;height:auto;display:block;border-radius:10px"></canvas>'
      + '<p style="font-size:13px;color:#6b6b6b;margin:6px 0 0;text-align:center">This is exactly what we print. Check every spelling before you order.</p>';
    var cv = document.getElementById('gy-bf-cv');
    var t = null;
    function go() {
      clearTimeout(t);
      t = setTimeout(function () { fontsReady().then(function () { render(cv); }); }, 120);
    }
    ['Title line', 'Names and birth months'].forEach(function (k) {
      var el = field(k); if (el) el.addEventListener('input', go);
    });
    fontsReady().then(go);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
    window.addEventListener('load', go);
    go();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
